module.exports = __webpack_public_path__ + "img/truck-and-mountain.26a0aa61.svg";